import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoFileUploadModule } from 'mojo-file-upload';
import { MojoTagModule } from 'mojo-tag';

import { AssignModule } from '@modules/assigns/assign.module';
import { AssignToJobModule } from '@shared/assign-to-job/assign-to-job.module';
import { SharedDirectivesModule } from '@shared/directives';
import { LocationInputModule } from '@shared/location/location-input.module';

import { CandidateSourceModule } from '../+details/+source/candidate-source.module';
import { CandidateUploadRoutingModule } from './candidate-upload-routing.module';
import { CandidateUploadComponent, UploadModalContainerComponent } from './containers';
import { CandidateUploadEffects } from './store/candidate-upload.effects';
import { candidateUploadReducer } from './store/candidate-upload.reducer';

const containers = [CandidateUploadComponent, UploadModalContainerComponent];

@NgModule({
  imports: [
    AssignModule,
    MatStepperModule,
    LocationInputModule,
    SharedDirectivesModule,
    CommonModule,
    ReactiveFormsModule,
    MojoAvatarModule,
    MojoTagModule,
    StoreModule.forFeature('candidateUpload', candidateUploadReducer),
    EffectsModule.forFeature([CandidateUploadEffects]),
    CandidateSourceModule,
    CandidateUploadRoutingModule,
    MojoFileUploadModule,
    AssignToJobModule,
  ],
  declarations: [...containers],
  exports: [...containers]
})
export class CandidateUploadModule { }
